'use client';

import type { ProjectType } from '~/model/ProjectType';
import { format, isPast } from 'date-fns';
import { useLocale, useTranslations } from 'next-intl';
import appConst from '~/const/appConst';

export const ProjectStepsStatus = ({ project }: { project: ProjectType }) => {
  const t = useTranslations('PROJECT');
  const locale = useLocale();

  return isPast(new Date(project?.end_at))
    ? (
        <div className="project-status__content" data-testid="ended">
          <div className="vp-title-s">{t('STEPS.ENDED')}</div>
          <p className="vp-body-s">
            {t('STEPS.ENDED_AT')}
            {' '}
            {format(
              new Date(project.end_at),
              'dd MMMM yyyy',
              {
                locale: appConst.locales[locale],
              },
            )}
          </p>
        </div>
      )
    : (
        <div className="project-status__content" data-testid="continued">
          <div className="vp-title-s">{t('STEPS.TO_BE_CONTINUED')}</div>
          <p className="vp-body-s">
            {t('STEPS.END_PROJECT')}
            {' '}
            {project?.end_at && format(
              new Date(project.end_at),
              'MMMM yyyy',
              {
                locale: appConst.locales[locale],
              },
            )}
          </p>
        </div>
      );
};
